const ROUTING_NUMBER_REGEX = /^\d{9}$/;
// Braintree US bank account numbers must be 4-17 digits.
const BANK_ACCOUNT_NUMBER_REGEX = /^\d{4,17}$/;
// US ZIP: 5 digits, optionally followed by -#### (ZIP+4).
const US_ZIP_REGEX = /^\d{5}(-\d{4})?$/;

// ABA routing number checksum: weighted sum of the 9 digits must be a
// multiple of 10. Filters out values like "123456789" that match the regex
// but Braintree will reject during tokenization.
const isRoutingChecksumValid = (digits: string): boolean => {
	const weights = [3, 7, 1, 3, 7, 1, 3, 7, 1];
	let sum = 0;
	for (let i = 0; i < 9; i++) {
		sum += Number(digits[i]) * (weights[i] ?? 0);
	}
	return sum > 0 && sum % 10 === 0;
};

export const isRoutingNumberValid = (value: string): boolean => {
	const trimmed = value.trim();
	return ROUTING_NUMBER_REGEX.test(trimmed) && isRoutingChecksumValid(trimmed);
};

export const isBankAccountNumberValid = (value: string): boolean =>
	BANK_ACCOUNT_NUMBER_REGEX.test(value.trim());

export const isUsZipValid = (value: string): boolean =>
	US_ZIP_REGEX.test(value.trim());

export type BillingAddressLike = {
	billingAddress1: string;
	city: string;
	state: string;
	zip: string;
};

export const isBillingAddressFilled = (values: BillingAddressLike): boolean =>
	values.billingAddress1.trim() !== "" &&
	values.city.trim() !== "" &&
	values.state.trim() !== "" &&
	values.zip.trim() !== "";
